"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./components/DocumentCard/index'));

//# sourceMappingURL=DocumentCard.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./DocumentCard.js
 ** module id = 164
 ** module chunks = 0
 **/